// extracted by mini-css-extract-plugin
export var fileUpload = "_fr-1";
export var modalButton = "_fr-0";